<div class="graph-toolbar">
   <pay-button
      [icon]="isZoomable ? 'unlock' : 'lock'"
      variant="ghost"
      size="sm"
      [pTooltip]="isZoomable ? 'Bloquear zoom' : 'Desbloquear zoom'"
      tooltipPosition="bottom"
      (clicked)="changeZoomManual()"
   ></pay-button>

   <div class="graph-toolbar__divider"></div>

   <pay-button
      icon="maximize-2"
      variant="ghost"
      size="sm"
      pTooltip="Centrar nodos"
      tooltipPosition="bottom"
      (clicked)="center()"
   ></pay-button>
   <pay-button
      icon="plus"
      variant="ghost"
      size="sm"
      pTooltip="Acercar"
      tooltipPosition="bottom"
      (clicked)="zoomIn()"
   ></pay-button>
   <pay-button
      icon="minus"
      variant="ghost"
      size="sm"
      pTooltip="Alejar"
      tooltipPosition="bottom"
      (clicked)="zoomOut()"
   ></pay-button>

   <div class="graph-toolbar__divider"></div>

   <pay-button
      icon="network"
      variant="ghost"
      size="sm"
      pTooltip="Ordenar nodos"
      tooltipPosition="bottom"
      (clicked)="onOrderNodes.emit()"
   ></pay-button>
   <pay-button
      icon="download"
      variant="ghost"
      size="sm"
      pTooltip="Descargar imagen"
      tooltipPosition="bottom"
      (clicked)="download()"
   ></pay-button>
</div>
